<template>
  <div
    data-qa="club_price_details"
    class="d-flex flex-column gr-4"
  >
    <div class="d-flex justify-space-between">
      <span class="text-body-1 text-secondary--text">
        Обычная цена
      </span>
      <span
        class="text-body-1 text--text"
        data-qa="club_price_details_full_price"
      >
        {{ priceList.full }}
      </span>
    </div>

    <div
      v-if="isNoCard"
      class="d-flex justify-space-between"
    >
      <div>
        <span class="text-body-1 text-secondary--text">
          Доступ к клубу
        </span>
        <div class="text-body-2 text-info--text">
          6 месяцев
        </div>
      </div>
      <span
        v-if="priceList.card"
        class="text-body-1 text--text"
        data-qa="club_price_details_card_price"
      >
        {{ priceList.card }}
      </span>
      <div
        v-else
        class="d-flex align-center gc-1"
        data-qa="club_price_details_price_card_free"
      >
        <div class="text-body-1 text--text">
          в подарок
        </div>
        <img
          src="/static/_v1/pd/icons/emoji/wrapped-present.png"
          width="20"
          height="20"
          alt="Подарок"
          data-qa="club_discount_card_free_icon"
        >
      </div>
    </div>

    <div class="d-flex justify-space-between mb-3">
      <span class="text-body-1 text-secondary--text">
        Скидка клуба
      </span>
      <span
        class="text-body-1 text-error--text"
        data-qa="club_price_details_club_discount_price"
      >
        -{{ priceList.clubDiscount }}
      </span>
    </div>

    <div class="text-h6 text--text d-flex justify-space-between">
      Итого
      <span data-qa="club_price_details_total_price">
        {{ priceList.total }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { getFormattedPrice } from 'www/utils'

const props = defineProps<{
  fullPrice: number
  totalPrice?: number | null
  cardPrice?: number | null
  isNoCard: boolean
}>()

const priceList = computed(() => ({
  full: getFormattedPrice(props.fullPrice),
  total: getFormattedPrice(props.totalPrice),
  card: props.cardPrice ? getFormattedPrice(props.cardPrice) : '',
  clubDiscount: getFormattedPrice(
    // В totalPrice учитыается цена карты, поэтому нужно добавить стоимость карты
    props.fullPrice - (props.totalPrice ?? 0) + (props.cardPrice ?? 0),
  ),
}))
</script>
